import ModalRibbon from './ModalRibbon'

export default ModalRibbon
